const features = [
  {
    icon: 'ri-flashlight-line',
    title: '全网最快更新',
    desc: '7×24小时全天候监控各大信息源，确保黑料事件第一时间推送到你面前，永远快人一步吃最新鲜的瓜。',
    color: 'primary',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多方交叉核实',
    desc: '每一条爆料发布前均经过编辑团队多轮核实与交叉验证，拒绝谣言与假料，只传递经过确认的真实信息。',
    color: 'accent',
  },
  {
    icon: 'ri-eye-off-line',
    title: '爆料人隐私保护',
    desc: '采用最高级别的匿名保护机制，所有爆料人身份信息严格加密存储，绝不泄露任何可能追溯来源的线索。',
    color: 'secondary',
  },
  {
    icon: 'ri-stack-line',
    title: '海量内容库',
    desc: '累计收录超过12,800起黑料事件，涵盖娱乐圈、网红圈、体育圈、商业圈等20余个内容品类。',
    color: 'primary',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全平台覆盖',
    desc: '支持PC端、移动端浏览器与微信公众号多端访问，无论身在何处都能随时随地畅快吃瓜不迷路。',
    color: 'accent',
  },
];

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  primary: { bg: 'bg-primary-500/10', text: 'text-primary-500', border: 'border-primary-500/20' },
  accent: { bg: 'bg-accent-500/10', text: 'text-accent-500', border: 'border-accent-500/20' },
  secondary: { bg: 'bg-secondary-500/10', text: 'text-secondary-500', border: 'border-secondary-500/20' },
};

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 bg-accent-500 rounded-full"></div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">平台优势</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {features.map((feat) => {
            const c = colorMap[feat.color];
            return (
              <div
                key={feat.title}
                className={`${c.bg} border ${c.border} rounded-xl p-5 text-center hover:scale-[1.02] transition-transform cursor-default`}
              >
                <div className={`w-12 h-12 mx-auto flex items-center justify-center rounded-xl ${c.text} mb-3`}>
                  <i className={`${feat.icon} text-2xl`}></i>
                </div>
                <h3 className="font-heading font-bold text-foreground-900 text-sm mb-2">{feat.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}